module.exports = __webpack_public_path__ + "img/brand-2.6c5e707c.png";